import { addMinutes, isAfter } from "date-fns"

import { type Shift } from "@/services/shiftsService"

export type ShiftDisplayStatus =
  | "planned"
  | "open"
  | "empty"
  | "in-progress"
  | "clocked-in"
  | "clocked-out"
  | "overdue"
  | "no-show"
  | "cancelled"
  | "unnotified-absence"

const DRIVER_INITIATED_CANCEL_REASONS = [
  "Sickness",
  "FamilyEmergency",
  "OtherWorkCommitments",
  "RequestedByDriver",
  "UnavailabilityRequest",
]

export const getShiftDisplayStatus = (shift: Shift): ShiftDisplayStatus => {
  const now = new Date()
  const inTime = shift.timesheet?.clockedInTime
  const outTime = shift.timesheet?.clockedOutTime
  if (outTime) {
    return "clocked-out"
  }
  if (inTime) {
    return "in-progress"
  }

  if (shift.status === "Cancelled") {
    if (
      shift.cancelledTime &&
      shift.cancelledReason &&
      DRIVER_INITIATED_CANCEL_REASONS.includes(shift.cancelledReason)
    ) {
      const start = new Date(shift.startTime).getTime()
      const cancelled = new Date(shift.cancelledTime).getTime()
      if (start - cancelled < 8 * 60 * 60 * 1000) {
        return "unnotified-absence"
      }
    }
    return "cancelled"
  }
  if (shift.status === "Unfulfilled") {
    return "empty"
  }

  const start = new Date(shift.startTime)
  if (isAfter(now, addMinutes(start, 20))) {
    return "no-show"
  }
  if (isAfter(now, addMinutes(start, 5))) {
    return "overdue"
  }

  if (shift.status === "Open") {
    return "open"
  }

  return "planned"
}
